import bcorp from './bcorp.png'
import fairTax from './fair_tax.png'
import iso27001 from './iso_27001_02.png'
import safeFacePledge from './safe_face_pledge.png'
import soc from './soc2.png'

export default {
  iso27001,
  soc,
  safeFacePledge,
  fairTax,
  bcorp
}
